// src/Footer.jsx
import React from "react";
import "./Footer.css";

function Footer({ isEnglish, onNavigate }) {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & Description */}
        <div className="footer-section">
          <h1 onClick={() => window.location.reload()} style={{ cursor: "pointer" }} className="footer-logo"><img src="./MainLogo.jpeg" alt=""></img></h1>
          <h2 onClick={() => window.location.reload()} style={{ cursor: "pointer" }}>DIGSMA</h2>
          <p>
            {isEnglish
              ? "We transform ideas into reality with creative solutions and professional execution. Relax, leave it to us!"
              : "نحوّل الأفكار إلى واقع من خلال حلول إبداعية وتنفيذ احترافي. استرخي، واتركها لنا!"}
          </p>
        </div>

        {/* Social Links */}
    <div className="footer-sections">
        <div className="footer-section">
          <h3>{isEnglish ? "Social Links" : "روابط التواصل"}</h3>
          <ul>
            <li><a href="https://www.facebook.com/share/1BkHb5atKL/">Facebook</a></li>
            <li><a href="#">Instagram</a></li>
            <li><a href="#">LinkedIn</a></li>
            <li><a href="#">YouTube</a></li>
            <li><a href="#">TikTok</a></li>
            <li><a href="#">Threads</a></li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>{isEnglish ? "Quick Links" : "روابط سريعة"}</h3>
          <ul>
            <li className="li"><button onClick={() => onNavigate("home")}>{isEnglish ? "Home" : "الرئيسية"}</button></li>
            <li className="li"><button onClick={() => onNavigate("About")}>{isEnglish ? "About" : "عنا"}</button></li>
            <li className="li"><button onClick={() => onNavigate("projects")}>{isEnglish ? "Projects" : "المشاريع"}</button></li>
            {/* <li className="li"><button onClick={() => onNavigate("blogs")}>{isEnglish ? "Blog" : "المدونة"}</button></li> */}
            <li className="li"><button onClick={() => onNavigate("contact")}>{isEnglish ? "Contact" : "تواصل"}</button></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>{isEnglish ? "Contact" : "تواصل معنا"}</h3>
      <a href="mailto:digisma7@gmail.com">digisma7@gmail.com</a>
          <br />
          <a
          href="https://wa.me/212783739706?text=مرحبا، انا مهتم بإحدى خدمات DIGISMA وأرغب بمعرفة المزيد من التفاصيل."
        target="_blank"
        rel="noopener noreferrer"
          >
            +212 783-739706
      </a>

        </div>
      </div>
    </div>
      <div className="footer-bottom">
        <p>© 2025 DIGISMA. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
